<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <!-- <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div> -->
        <form class="w-full" id="guestUserForm" @submit.prevent>
          <div class="flex flex-wrap">
            <div-title
              v-if="!newGuestUser"
              class="w-full text-left px-3 pb-3 text-2xl font-bold"
              :colorP="colorP"
            >
              Actualización de Usuario
            </div-title>
            <div-title
              v-if="newGuestUser"
              class="w-full text-left px-3 pb-3 text-2xl font-bold"
              :colorP="colorP"
            >
              Nuevo Usuario Invitado
            </div-title>

            <div class="w-3/12 lg:w-4/12">
              <div class="relative w-20 lg:w-40 h-20 lg:h-40">
                <!-- <img src="https://i.pravatar.cc/300" class="h-30 w-30 mt-1 rounded-full border-solid border-4 border-teal-500"> -->
                <img
                  :src="guestUser.profile_image"
                  class="h-full w-full object-cover mt-1 rounded-full"
                  alt
                  v-bind:class="[
                    guestUser.inactive
                      ? 'border-solid border-4 border-cdmx-red'
                      : 'border-solid border-4 border-cdmx-green'
                  ]"
                />
              </div>
            </div>
            <div class="flex flex-col w-9/12 lg:w-8/12 pl-4">
              <!-- <form class="w-full max-w-lg" id="guestUserForm" @submit.prevent> -->
              <div class="w-full max-w-lg">
                <div class="flex flex-wrap -mx-3" v-if="newGuestUser">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="email"
                      >Correo *</label
                    >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      type="text"
                      name="email"
                      v-model="guestUser.email"
                    />
                    <p v-if="errors.email" class="text-red-500 text-xs italic">
                      Ingrese un correo electrónico.
                    </p>
                    <p
                      v-if="errors.valid_email"
                      class="text-red-500 text-xs italic"
                    >
                      Ingrese un correo electrónico válido.
                    </p>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="category_id"
                      >Perfil *</label
                    >
                    <div class="relative">
                      <select
                        id="category_id"
                        v-model="guestUser.category_id"
                        name="category_id"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option
                          v-for="(option, index) in guestUserTypes"
                          v-bind:value="option.id"
                          :key="index"
                        >
                          {{ option.name_category }}
                        </option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.category"
                      class="text-red-500 text-xs italic pt-3"
                    >
                      Seleccione un tipo de categoría.
                    </p>
                  </div>
                </div>

                <div class="flex w-full justify-end mt-3">
                  <btn-action
                    class="px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="saveGuestUser()"
                    :colorT="colorT"
                  >
                    Guardar
                  </btn-action>
                  <button
                    class="ml-2 bg-red-700 px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="close()"
                  >
                    Cerrar
                  </button>
                </div>
                <!-- </form> -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <alert-dialog :showing="showingSuccessEdit">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Rol de usuario guardado Exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessEdit = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingWait">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Enviando invitación. . . espere un poco</div>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessNew">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Invitación enviada</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessNew = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

import { styled } from "@egoist/vue-emotion";

const DivTitle = styled("div")`
  color: ${props => props.colorP};
`;

const BtnAction = styled("button")`
  background-color: ${props => props.colorT};
`;

export default {
  name: "guest-user-modal",
  data() {
    return {
      aux_guestUser: null,
      guestUser: {
        device_id: null,
        name: null,
        last_name: null,
        auth_id: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        email: null,
        category_id: null,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
      },
      options: [
        { text: "Hombre", value: "H" },
        { text: "Mujer", value: "M" }
      ],
      errors: {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        auth_id: false,
        valid_phone: false,
        address: false,
        age: false,
        sex: false,
        category: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccessNew: false,
      showingSuccessEdit: false,
      showingWait: false,
      showingError: false,
      guestUserTypes: [],
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
          //"Content-Type": 'multipart/form-data'
        }
      },
      configBinnacle: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    newGuestUser: {
      required: true,
      type: Boolean
    },
    colorP: {
      required: true
    },
    colorS: {
      required: true
    },
    colorT: {
      required: true
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  created() {
    let that = this;
    /*     this.$socket.$subscribe("updateCategoryAuthorityToMonitor", () => {
      that.fetchUserTypes();
    }); */
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
    this.fetchUserTypes();
  },
  components: {
    AlertDialog,
    DivTitle,
    BtnAction
  },
  methods: {
    reset: function () {
      this.guestUser = {
        name: null,
        last_name: null,
        auth_id: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        email: null,
        password: null,
        password_again: null,
        category_id: null,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
      };
      this.errors = {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        auth_id: false,
        valid_phone: false,
        address: false,
        age: false,
        sex: false,
        category: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData: function (guestUser) {
      this.guestUser = Object.assign({}, guestUser);
      this.aux_guestUser = Object.assign({}, guestUser);
    },

    fetchUserTypes() {
      this.axios
        .get("apidev/users/categories", this.config)
        .then(response => {
          this.guestUserTypes = response.data.categories;
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    saveGuestUser() {
      const form = document.getElementById("guestUserForm");
      const formData = new FormData(form);

      if (this.newGuestUser) {
        const validForm = this.checkFormNewGuestUser(formData);
        if (validForm) {
          this.showingWait = true;
          this.axios
            .put(
              "apidev/users/guest/new",
              {
                email: this.guestUser.email,
                category: this.guestUser.category_id,
                email_created: localStorage.getItem("email")
              },
              this.config
            )
            .then(response => {
              this.showingWait = false;
              this.showingSuccessNew = true;
              //guarda bitácora
              let name = localStorage.getItem("name");
              let user_id = localStorage.getItem("user_id");
              this.guestUser.name_category = this.guestUserTypes.filter(
                type => {
                  if (this.guestUser.category_id == type.id) return type;
                }
              )[0]["name_category"];
              //// removed console log

              this.axios
                .post(
                  "/apidev/bitacoras/save/",
                  {
                    module: "Invitaciones",
                    action: "Invitación enviada",
                    observation:
                      name +
                      " invitó a '" +
                      this.guestUser.email +
                      "' con el rol de " +
                      this.guestUser.name_category,
                    email: localStorage.getItem("email"),
                    user_id: localStorage.getItem("user_id")
                  },
                  this.config
                )
                .then(response => {
                  //// removed console log
                })
                .catch(error => {
                  // removed console log
                });
              //FIN guarda bitácora

              this.$emit("updateAllGuestUser");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              this.showingWait = false;
              // removed console log
              if (error.response.status == 400 || error.response.status == 409) {
                this.errors.codeError =
                  "Ya hay otra persona que tiene esta dirección de correo electrónico. Pruebe con otro correo";
              }
              if (
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              this.showingError = true;
            });
        }
      } else {
        //// removed console log
        let oldRol = this.guestUser.name_category;
        const validForm = this.checkFormUpdateGuestUser(formData);
        if (validForm) {
          this.axios
            .put(
              "apidev/users/guest/edit",
              {
                category: this.guestUser.category_id,
                id: this.guestUser.id
              },
              this.config
            )
            .then(response => {
              this.guestUser.name_category = this.guestUserTypes.filter(
                type => {
                  if (this.guestUser.category_id == type.id) return type;
                }
              )[0]["name_category"];

              this.showingSuccessEdit = true;

              //guarda bitácora
              let name = localStorage.getItem("name");
              let user_id = localStorage.getItem("user_id");
              this.guestUser.name_category = this.guestUserTypes.filter(
                type => {
                  if (this.guestUser.category_id == type.id) return type;
                }
              )[0]["name_category"];
              //// removed console log

              this.axios
                .post(
                  "/apidev/bitacoras/save/",
                  {
                    module: "Invitaciones",
                    action: "Invitación modificada",
                    observation:
                      name +
                      " cambió el rol de invitación para '" +
                      this.guestUser.email +
                      "' de " +
                      oldRol +
                      " a " +
                      this.guestUser.name_category,
                    email: localStorage.getItem("email"),
                    user_id: localStorage.getItem("user_id")
                  },
                  this.config
                )
                .then(response => {
                  //// removed console log
                })
                .catch(error => {
                  // removed console log
                });
              //FIN guarda bitácora

              this.$emit("updateGuestUser", this.guestUser);
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              // removed console log
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              this.showingError = true;
            });
        }
      }
    },

    checkFormNewGuestUser: function (data) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var rePhone = /^([0-9])*$/;

      if (data.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(data.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (data.get("category_id") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      }

      if (
        this.errors.email ||
        this.errors.valid_email ||
        this.errors.category
      ) {
        return false;
      }

      return true;
    },

    checkFormUpdateGuestUser: function (data) {
      var rePhone = /^([0-9])*$/;

      if (data.get("category_id") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      }

      if (this.errors.category) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
